import { render } from "./LandingRegisterForm.vue?vue&type=template&id=502da0bc&scoped=true"
import script from "./LandingRegisterForm.vue?vue&type=script&lang=js"
export * from "./LandingRegisterForm.vue?vue&type=script&lang=js"

import "./LandingRegisterForm.vue?vue&type=style&index=0&id=502da0bc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502da0bc"]])

export default __exports__